// extracted by mini-css-extract-plugin
module.exports =  {"sidebarRoute":"sidebarRoute__iUkJL"};